import SanctumMiddleware from "@@/middlewares/SanctumMiddleware";
import RouteExistsMiddleware from "@@/middlewares/RouteExistsMiddleware";
import LocaleExistsMiddleware from "@@/middlewares/LocaleExistsMiddleware";
import localeSelectedMiddleware from "@@/middlewares/LocaleSelectedMiddleware";
import AuthPassedMiddleware from "@@/middlewares/AuthPassedMiddleware";
import authRoutes from "@/routes/auth";
import errorRoutes from "@/routes/error";
import adminRoutes from "@/routes/admin";
import sharedRoutes from "@/routes/shared";
import redactorRoutes from "@/routes/redactor.js";
import userAdminRoutes from "@/routes/user_admin.js";
import userWorkerRoutes from "@/routes/user_worker.js";
import userSuperRedactorRoutes from "@/routes/user_super_redactor.js";

const routes = [
	{
		path: "",
		redirect: {
			name: "main",
			params: {
				locale: "pl",
			},
		},
	},
	{
		name: "main",
		path: `/:locale`,
		component: () => import("@/views/Index.vue"),
		meta: {
			middleware: [SanctumMiddleware, LocaleExistsMiddleware, localeSelectedMiddleware],
			breadcrumbs: {
				hidden: true,
			},
		},
		redirect: {
			name: "dashboard",
		},
		children: [
			{
				name: "demo",
				path: "demo",
				component: () => import("@/views/pages/demo/DemoComponents.vue"),
				meta: {
					middleware: [AuthPassedMiddleware],
					layout: "default",
				},
			},
			{
				name: "auth",
				path: "",
				component: () => import("@/views/Blank.vue"),
				meta: {
					layout: "clear",
				},
				children: [...authRoutes],
			},
			{
				name: "app",
				path: "",
				component: () => import("@/views/Blank.vue"),
				meta: {
					middleware: [AuthPassedMiddleware],
					layout: "default",
					breadcrumbs: {
						hidden: true,
					},
				},
				children: [
					...sharedRoutes,
					{
						name: "admin",
						path: "admin",
						component: () => import("@/views/Blank.vue"),
						meta: {
							middleware: [AuthPassedMiddleware],
						},
						children: [...adminRoutes],
					},
					{
						name: "redactor",
						path: "redactor",
						component: () => import("@/views/Blank.vue"),
						meta: {
							middleware: [AuthPassedMiddleware],
						},
						children: [...redactorRoutes],
					},
					{
						name: "userAdmin",
						path: "user-admin",
						component: () => import("@/views/Blank.vue"),
						meta: {
							middleware: [AuthPassedMiddleware],
						},
						children: [...userAdminRoutes],
					},
					{
						name: "userWorker",
						path: "user-worker",
						component: () => import("@/views/Blank.vue"),
						meta: {
							middleware: [AuthPassedMiddleware],
						},
						children: [...userWorkerRoutes],
					},
					{
						name: "userSuperRedactor",
						path: "user-super-redactor",
						component: () => import("@/views/Blank.vue"),
						meta: {
							middleware: [AuthPassedMiddleware],
						},
						children: [...userSuperRedactorRoutes],
					},
				],
			},
			{
				name: "errors",
				path: "",
				component: () => import("@/views/Blank.vue"),
				meta: {
					layout: "error",
				},
				children: [...errorRoutes],
			},
		],
	},
	{
		path: "/:path(.*)*",
		component: () => import("@/views/Blank.vue"),
		meta: {
			middleware: [LocaleExistsMiddleware, RouteExistsMiddleware],
		},
	},
];

export default routes;
